import(/* webpackMode: "eager" */ "/vercel/path0/apps/ocnc/app/rules_tour/page.tsx");
